<template>
  <div class="w-full flex flex-col gap-0.5 p-1">
    <button 
      v-for="option in options" 
      :key="option.name"
      class="w-full flex items-center px-2 py-1.5 rounded-md transition-colors duration-100"
      :class="isSelected(option) ? 'bg-neutral-50' : 'hover:bg-neutral-25'"
      @click="selectOption(option)"
    >
      <BaseText type="body" size="sm" class="text-text-muted">
        {{ option.name }}
      </BaseText>
      <CheckmarkIcon v-if="isSelected(option)" class="ml-auto text-secondary-green-300" />
    </button>
  </div>
</template>

<script>
import CheckmarkIcon from '../../../globals/Icons/CheckmarkIcon.vue'

export default {
  name: 'RunTimeFilter',
  components: {
    CheckmarkIcon
  },
  props: {
    selection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      options: [
        { name: 'Under 7 Days', value: { min: null, max: 7 } },
        { name: 'Over 7 Days', value: { min: 8, max: null } },
        { name: 'Over 15 Days', value: { min: 16, max: null } },
        { name: 'Over 30 Days', value: { min: 31, max: null } },
        { name: 'Over 3 months', value: { min: 91, max: null } },
        { name: 'Over 6 months', value: { min: 181, max: null } },
        { name: 'Over 12 months', value: { min: 361, max: null } }
      ]
    }
  },
  methods: {
    isSelected (option) {
      const { min, max } = this.selection
      return min === option.value.min && max === option.value.max
    },
    selectOption (option) {
      if (this.isSelected(option)) {
        this.$emit('update', null)
      } else {
        this.$emit('update', option.value)
      }
    }
  }
}
</script>

<style scoped>
</style>
